<template>
    <div class="FingerPose" :class="{ disable : disable }">  
      <video class="FingerPose__video" id="video" playsinline style="
            -webkit-transform: scaleX(-1);
            transform: scaleX(-1);
            visibility: auto;
            width: auto;
            height: auto;
            position: absolute;">
        </video>
      <div class="FingerPose__hand ">{{ fdl }}</div>
      <div class="FingerPose__hand right">{{ fdl }}</div>  
    </div>
</template>

<script>

import gsap from "gsap"
const handpose = require('@tensorflow-models/handpose')
require('@tensorflow/tfjs-backend-webgl');

import fp from 'fingerpose'

export default {

  name: 'FingerPose',
  render: h => h(), 
  data: ()=>({

    fdl: 0,
    fdr: 0,
    plx: 0,
    prx: 0,
    nwl: 0,
    nwr: 0,
    lft_locked : false,
    rgt_locked: false,
    disable: false, 
    sure: 0,
    nw:'',
    old: ''

  }),
  beforeDestroy() {
    // if(this.rafID)
    //   cancelAnimationFrame(this.rafID)
    // this.removeFingerPose()
  },
  mounted() {
    console.log('FingerPose');
    const knownGestures = [ fp.Gestures.VictoryGesture, fp.Gestures.ThumbsUpGesture ]
    this.$numeros = ['', 'UN', 'DEUX', 'TROIS', 'QUATRE', 'CINQ']
    this.$GE = new fp.GestureEstimator(knownGestures)
    this.init()
  },

  methods: {

    setupCamera: async function() { 
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error(
            'Browser API navigator.mediaDevices.getUserMedia not available')
      }
      const video = document.getElementById('video')
      const stream = await navigator.mediaDevices.getUserMedia({
        'audio': false,
        'video': {
          facingMode: 'user',
          width: 320,
          height: 240
        },
      })
      video.srcObject = stream
      return new Promise((resolve) => {
        video.onloadedmetadata = () => { resolve(video) }
      })
    },

    loadVideo: async function() {
      const video = await this.setupCamera()
      video.play()
      return video
    },

    init: async function() {
      
      this.$model = await handpose.load();
      let video
      try {
        video = await this.loadVideo()
        this.onLoop()

      } catch (e) {
        
        console.log('catch '+ e);

        throw e;
      }

    },


    analyzeData(data) {

      let res = { open:[], half:[], close:[], vertical:[], diagnal:[] }
      _.each(data, (finger)=>{

        if(finger[1].indexOf('Full') != -1)
          res.close.push(finger[0])

        if(finger[1].indexOf('Half') != -1)
          res.half.push(finger[0])

        if(finger[1].indexOf('No') != -1)
          res.open.push(finger[0])


      })

      return res

    },




    onLoop: async function() {

      this.$predictions = await this.$model.estimateHands(document.querySelector("video"))

      let res = ''

      if(this.$predictions.length > 0){

        _.each(this.$predictions, (prediction)=>{
          const est = this.$GE.estimate(prediction.landmarks, 9)
          const analyze = this.analyzeData(est.poseData)


          if(analyze['open'].length > 0) {

            this.nw = analyze['open'].length

            if(this.old == this.nw)
              this.sure += 1
            else
              this.sure = 0

            if(this.sure >= 5)
              res = this.$numeros[(analyze['open'].length)]

            this.old = this.nw
          }

          console.log(analyze['open']);

          // if(est.gestures.length > 0) {
          //   let result = est.gestures.reduce((p, c) => { 
          //     return (p.score > c.score) ? p : c
          //   })
          //   console.log(result);
          //   if(result.score == 10) {
          //     res = result.name
          //   }
          // }

        })
      }


      this.fdl = res

        // LEFT HAND

        // const finger = 0
        // const keypoints = this.$predictions[0].landmarks;
        // const hand = keypoints[finger][0]

        // this.fdl = hand

        // if(hand < 200)
        //    this.motionLeft()    
      // }
        
      this.rafID = requestAnimationFrame(this.onLoop)   
    },
    // removeScreens() {
    //   console.log('x');
    //   gsap.set('.FingerPose-debugger', { 'display' : 'none' })
    // },

    // removeFingerPose() {
    //   // TODO . 
    // },
    motionLeft() {
      if(this.lft_locked == true)
        return
      this.lft_locked = true
      this.$store.commit('app/MOTION_LEFT')
      gsap.delayedCall(.5, ()=>{ this.lft_locked = false })
    },
  }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.FingerPose
  position absolute 
  top 0 
  left 0
  width 100vw

  &__hand 
    position absolute
    border 1px solid red
    padding 4px 16px
    width 300px
    background red
    text-align center
    height 27px

    &.right 
      right 0

  &__video 
    top 50px
    right 13px

   
</style>















